import { useState, useEffect } from 'react';
import axios from 'axios';

const path = '/api/agencyZoom/v1/getAgencyZoomEnabled';

export function useGetAgencyZoomEnabled(getAgencyZoomEnableState) {
  const [agencyZoomEnabled, setAgencyZoomEnabled] = useState({
    fetching: false,
    error: false,
    success: false,
    data: undefined,
  });
  useEffect(() => {
    const getAgencyZoomEnabled = async () => {
      setAgencyZoomEnabled({ fetching: true, error: false, success: false });
      try {
        const response = await axios.get(path);
        if (response.status !== 200) {
          setAgencyZoomEnabled({
            fetching: false,
            success: false,
            error: true,
            data: undefined,
          });
        } else {
          setAgencyZoomEnabled({
            fetching: false,
            success: true,
            error: false,
            data: response.data.data,
          });
        }
      } catch (e) {
        setAgencyZoomEnabled({ fetching: false, error: true, success: false });
      }
    };
    if (getAgencyZoomEnableState === true) {
      getAgencyZoomEnabled();
    }
  }, [getAgencyZoomEnableState]);
  return agencyZoomEnabled;
}
